import {Component, HostBinding, input} from '@angular/core';
import {Rating, WineProduct} from '@core/interfaces/generated/graphql';
import {CustomerRatingComponent} from '@layout/components/product/customer-rating/customer-ratingcomponent';
import {
  ProductCompactRatingPointsComponent
} from '@layout/components/product/product-compact-rating/product-compact-rating-points/product-compact-rating-points.component';


@Component({
  selector: 'app-product-compact-rating',
  templateUrl: './product-compact-rating.component.html',
  styleUrls: ['./product-compact-rating.component.scss'],
  imports: [ProductCompactRatingPointsComponent, CustomerRatingComponent]
})
export class ProductCompactRatingComponent {

  rating = input.required<Rating>();
  product = input<WineProduct>();
  isCustomerRating = input<boolean>(false);
  productPageDesign = input<boolean>(false);

  @HostBinding('class.product-page-design')
  get isProductPageDesign() {
    return this.productPageDesign();
  }

}
